<template>
  <ReferenceComponentParentList
    v-if="content.length"
    :searchList="content"
    :componentType="componentType"
  >
    <template #header>
      <BaseSubHeading
        weight="600"
        size="medium"
        color="monochrome-06"
        className="reference-list__header"
      >
        Keyboard Shortcuts:
      </BaseSubHeading>
    </template>

    <template #item="{ option }">
      <div class="reference-list__separate">
        <BaseSubHeading
          weight="400"
          size="medium"
          color="monochrome-07"
          className="reference-list__separate-left"
        >
          {{ $t(`reference.${option}.key`) }}
        </BaseSubHeading>
        <BaseSubHeading
          weight="400"
          size="medium"
          color="monochrome-05"
          darkColor="monochrome-04"
          className="reference-list__separate-right"
        >
          {{ $t(`reference.${option}.desc`) }}
        </BaseSubHeading>
      </div>
    </template>
  </ReferenceComponentParentList>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"
import { Action, Getter } from "s-vuex-class"

import ReferenceComponentParentList from "@/components/Reference/helpers/ReferenceComponentParentList.vue"

import { Item } from "@/models"
import { UserSettings } from "@/models/User"
import { ReferenceConfig } from "@/plugins/extensions/Reference"
import { ReferenceType } from "@/plugins/extensions/ReferenceType"
import { Actions, Getters } from "@/store"

const components = {
  ReferenceComponentParentList
}

type ReferenceEditor = {
  options: {
    extensions: Array<{ name: string }>
  }
}

const tips = [
  { option: "item", types: [ReferenceType.ITEM] },
  { option: "task", types: [ReferenceType.TASK] },
  { option: "sprint", types: [ReferenceType.SPRINT] },
  { option: "epic", types: [ReferenceType.EPIC] },
  { option: "idea", types: [ReferenceType.IDEA] },
  { option: "project", types: [ReferenceType.PROJECT] },
  { option: "milestone", types: [ReferenceType.MILESTONE] },
  { option: "team", types: [ReferenceType.TEAM] },
  { option: "file", types: [ReferenceType.FILE, ReferenceType.FILE_LINK] }
]

@Options({
  name: "TipList",
  components
})
export default class extends Vue {
  @Prop() readonly editor: ReferenceEditor | undefined
  @Action(Actions.UPDATE_PROFILE_SETTINGS) updateProfileSettings: ({
    settings,
    immediate
  }: {
    settings: UserSettings
    immediate?: boolean
  }) => void
  // TODO: Was removed after update API on backend, need to be added after update API on frontend
  @Getter(Getters.GET_ITEM) readonly item: Item

  componentType = ReferenceType.TIP

  get content() {
    const enabledExtensions = new Set(
      this.editor?.options.extensions.map(extension => extension.name)
    )
    return tips
      .filter(({ types }) => {
        return types.some(type => enabledExtensions.has(ReferenceConfig[type].extensionName))
      })
      .map(({ option }) => option)
  }
}
</script>
